import React, { useEffect, useRef, useState } from 'react';
import { errorToast, getJWTToken, getLocalStorageItem, useOutsideClick } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { StatCard, STAT_ICONS } from '../../component/common/designSystem';
import { CompanyApi } from '../../api/companyApi';

function InstantSupportInsights(props) {
  const { companyId } = JSON.parse(localStorage.getItem('userData')); // userType can also be used

  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  // Modified state setters to also save to local storage
  const [companyTotaltSeatsInsights, setCompanyTotalSeatsInsights] = useState(() => {
    const savedTotalSeats = localStorage.getItem('companyTotalSeats');
    return savedTotalSeats ? parseInt(savedTotalSeats, 10) : 0;
  });

  const [companyUsedSeatsInights, setCompanyUsedSeatsInsights] = useState(() => {
    const savedUsedSeats = localStorage.getItem('companyUsedSeats');
    return savedUsedSeats ? parseInt(savedUsedSeats, 10) : 0;
  });

  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  // Custom setter for total seats that also saves to local storage
  const updateCompanyTotalSeats = (value) => {
    setCompanyTotalSeatsInsights(value);
    localStorage.setItem('companyTotalSeats', value.toString());
  };

  // Custom setter for used seats that also saves to local storage
  const updateCompanyUsedSeats = (value) => {
    setCompanyUsedSeatsInsights(value);
    localStorage.setItem('companyUsedSeats', value.toString());
  };

  const subAdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.seats}
      title={'Total Seats'}
      value={companyTotaltSeatsInsights === 99999 ? '-' : companyTotaltSeatsInsights}
    />,
    <StatCard
      icon={STAT_ICONS.activeUsers}
      title={'Used Seats'}
      value={companyUsedSeatsInights}
    />,
    <StatCard
      icon={STAT_ICONS.newUsers}
      title={'Available Seats'}
      value={
        companyTotaltSeatsInsights === 99999
          ? '-'
          : Math.max(0, companyTotaltSeatsInsights - companyUsedSeatsInights)
      }
    />
  ];

  // Use the needsRefresh prop to trigger data fetching
  useEffect(() => {
    if (props.needsRefresh) {
      setLoader(true);

      CompanyApi.getInstantSupportInights(companyId)
        .then((response) => {
          if (response?.status === 200) {
            console.log('Refreshed Insights Data:', response?.data?.data);
            updateCompanyTotalSeats(response?.data?.data?.totalSeats);
            updateCompanyUsedSeats(response?.data?.data?.activeUsersCount);
          }
        })
        .catch((error) => {
          console.error('Error fetching insights data:', error);
        })
        .finally(() => {
          setLoader(false);
          props.refreshCompleted(); // Notify parent that refresh is done
        });
    }
  }, [props.needsRefresh]); // Add needsRefresh as a dependency

  // Keep the initial data loading separate
  useEffect(() => {
    CompanyApi.getInstantSupportInights(companyId).then((response) => {
      if (response?.status === 200) {
        updateCompanyTotalSeats(response?.data?.data?.totalSeats);
        updateCompanyUsedSeats(response?.data?.data?.activeUsersCount);
      }
    });
  }, []); // This runs only on component mount

  return (
    <>
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 mt-5">
        {subAdminStatusCards.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </div>
    </>
  );
}

export default InstantSupportInsights;
